import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import EditLocation from './EditLocation';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';

function action({ store, intl, params }) {
    const title = intl.formatMessage(messages.editLocationHeading);

    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    if (!restrictUrls('/siteadmin/location', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: (
            <AdminLayout>
                <EditLocation id={Number(params.id)} title={title} />
            </AdminLayout>
        ),
    };
}

export default action;
